import React, {useEffect, useState} from 'react'

import {NavLink, useNavigate } from 'react-router-dom'
import { LiaExchangeAltSolid } from "react-icons/lia";

import { AiFillHome } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { AiOutlineAlignRight } from "react-icons/ai";
import { IoSettingsSharp } from "react-icons/io5";
import { VscDebugContinueSmall } from "react-icons/vsc";
import { VscDebugLineByLine } from "react-icons/vsc";
import { IoWalletOutline } from "react-icons/io5";

import useToolsStore from '../../stores/ToolsStore';
import useConsoleStore from '../../stores/ConsoleStore';
import useAlgoStore from '../../stores/AlgosStore';
import useTriggerStore from '../../stores/TriggersStore';
import useTradeStore from '../../stores/TradesStore';

function MobileNavbar() {
  const [stateNotifs, setStateNotifs] = useState(0)
  const [consoleNotifs, setConsoleNotifs] = useState(false)
  
  const {setMobileComponent, mobileComponent} = useToolsStore()
  const algoCount = useAlgoStore((state) => state.algo_count)
  const triggerCount = useTriggerStore((state) => state.trigger_count)
  const tradeCount = useTradeStore((state) => state.trade_count)

  const outputs = useConsoleStore((state) => state.outputs)


  useEffect(() => {

    const isEmpty = (obj) => {
      return Object.keys(obj).length === 0;
    };

    var notif = isEmpty(outputs)

    setStateNotifs(algoCount + triggerCount + tradeCount)
    setConsoleNotifs(!notif)
  }, [algoCount, tradeCount, triggerCount, outputs])

  const changeComponent = (component) => {
    setMobileComponent(component)
  }
  return (
    <div className="mobile_navbar_container">
      <button id="console" onClick={() => changeComponent("console")} className={`mobile_nav_link btn ${mobileComponent === "console" ? "mobile_active_link" : ""}`}>
        <VscDebugLineByLine  className='mobile_nav_icon'/>
        <h3>Console</h3>
        {consoleNotifs ? <span className='live_dot'>"</span>: null}
      </button>
      
      <button  id="my_orders" onClick={() => changeComponent("my_orders")} className={`mobile_nav_link btn ${mobileComponent === "my_orders" ? "mobile_active_link" : ""}`}>
        <AiOutlineAlignRight  className='mobile_nav_icon'/>
        <h3>My Orders</h3>
        {stateNotifs && stateNotifs > 0 ? <span className='state_notif'>{stateNotifs > 99 ? "99+" : stateNotifs}</span>: null}
      </button>
      <button id="trades" onClick={() => changeComponent("trades")} className={` mobile_nav_link btn ${mobileComponent === "trades" ? "mobile_active_link" : ""}`}>
        <LiaExchangeAltSolid  className='mobile_nav_icon'/>
        <h3>Trade</h3>
      </button>

      {/* <button id="settings" onClick={() => changeComponent('settings')} className={`mobile_nav_link  btn ${mobileComponent === "settings" ? "  mobile_active_link" : ""}`}>
        <IoSettingsSharp  className='mobile_nav_icon'/>
        <h3>Settings</h3>
      </button> */}
      <button id="positions" onClick={() => changeComponent('positions')} className={`mobile_nav_link  btn ${mobileComponent === "positions" ? "  mobile_active_link" : ""}`}>
        <IoWalletOutline  className='mobile_nav_icon'/>
        <h3>Positions</h3>
      </button>
      

      <button id="my_profile" onClick={() => changeComponent('my_profile')} className={`mobile_nav_link btn ${mobileComponent === "my_profile" ? "mobile_active_link" : ""}`}>
        <CgProfile  className='mobile_nav_icon'/>
        <h3>My Profile</h3>
      </button>

    </div>
  )
}

export default MobileNavbar